window.Carousel = SiCarousel.extend({
    render: function () {
        SiCarousel.prototype.render.call(this);

        this.moveSlidesOnSwipe();
    },

    updateCarouselItemPositions: function () {
        this.animateCarouselItem(this.$slide.eq(this.index));
    },

    animateCarouselItem: function ($element) {
        this.itemWidth = this.$slide.width();
        var xPosition = -((this.index * this.itemWidth) + (this.index * 10));
        TweenMax.to(this.$carousel, 0.6, {
            x: xPosition,
            ease: Power4.easeInOut,
            onStart: this.animationStarted,
            onStartParams: [this],
            onComplete: this.animationComplete,
            onCompleteParams: [this],
        });
        this.fadeCardsAfterSlide();
    },

    animationComplete: function (e) {
        SiCarousel.prototype.animationComplete.call(this, e);
    },

    fadeCardsAfterSlide: function () {
        var self = this;
        for (var i = 0; i < this.$slide.length; i++) {
            var $box = this.$slide[i];
            // if (i != this.index) {
            TweenMax.to($box, 0.6, {
                opacity: 0,
                ease: Power4.easeInOut,
                onComplete: function () {
                    self.$slide.css("visibility", "hidden");
                }
            });
            TweenMax.to(this.$slide.eq(this.index), 0.65, {
                opacity: 1,
                ease: Power4.easeInOut,
                visibility: "visible",
            });
        }
    },

    moveSlidesOnSwipe: function () {
        var self = this;
        var proxy = document.createElement("div");
        this.draggable = Draggable.create(proxy, {
            trigger: ".slide",
            type: "x",
            minimumMovement: 10,
            dragClickables: false,
            onDragStart: function () {
                if (this.getDirection() === "left") {
                    self.next();
                } else {
                    self.previous();
                }
            }
        });
    },

    getContent: function (data) {
        return Handlebars.templates["carousel/carousel"](data);
    },

    getData: function ($xml, language) {
        var data = SiCarousel.prototype.getData.call(this, $xml, language);
        data.imageDescription = LanguageManager.getString("anya");
        data.image = data.image.trim();
        // console.info("Carousel.Data", data);
        return data;
    },

    createNavigation: function () {
        this.$carouselWrapper = this.$el.find(".carousel-wrapper");

        this.progressDots = new ProgressDotsUI({
            isInsertBefore: true,
            $el: this.$carouselWrapper,
            index: 0,
            type: ProgressDotsUI.ALIGN_HORIZONTAL,
            layout: ProgressDotsUI.LAYOUT_TABLE,
            isDotClickable: false,
            navigation: true,
            dotCount: this.data.items.length
        });

        this.listenTo(this.progressDots, "onSelect", function (e) {
            this.select(e.index);
        });

        this.listenTo(this.progressDots, "onPreviousClicked", function (e) {
            this.previous();
        }, this);

        this.listenTo(this.progressDots, "onNextClicked", function (e) {
            this.next();
        }, this);
    },
    next: function () {
        if (this.$carouselWrapper.find(".next-button").hasClass('disabled')) return false;
        const $slide = this.$slide.eq(this.index)[0];

        const valid = Array.from($slide.querySelectorAll('*'))
            .filter(el => !!el.validation)
            .map(el => {
                el.validation.validate();
                return el;
            })
            .filter(el => el.validation.invalid())
            .length === 0
            ;

        if (!valid) {
            this.shakeSlide();
            return;
        }

        SiCarousel.prototype.next.call(this);
    },

    shakeSlide: function () {
        var $slide = this.$slide.eq(this.index)
        var violence = 1;
        var duration = 0.8;
        var points = 6;
        TweenLite.fromTo($slide, duration, {
            x: -1,
        }, {
            x: 1,
            ease: RoughEase.ease.config({
                strength: 8 * violence,
                points: points * violence,
                template: Linear.easeNone,
                randomize: false
            }),
            clearProps: "x"
        });
    }
});
